var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div layout=\"row\" layout-align=\"start start\" layout-fill>\n<div flex=\"20\" hide-sm hide-xs hide-gt-sm show-lg show-gt-lg></div>\n<md-card flex=\"grow\" layout=\"column\" class=\"md-whiteframe-5dp\">\n<div layout=\"column\">\n<div layout=\"row\">\n<div class=\"md-body-2\" layout=\"column\" layout-fill layout-padding>\n<div class=\"md-subhead\" style=\"font-weight:bold;\" translate=\"yes\">Terms and Conditions</div>\n<div ng-bind-html=\"terms.content\"></div>\n</div>\n</div>\n</div>\n</md-card>\n<div flex=\"20\" hide-sm hide-xs hide-gt-sm show-lg show-gt-lg></div>\n</div>\n";
var id1="components/public/terms.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/public/terms.html
// module id = 687
// module chunks = 0